import axios from 'axios'
// import * as firebase from 'firebase/app'
// import 'firebase/auth'
// import 'firebase/storage'
import firebase from 'firebase'
import OAlert from '../utils/OAlert/OAlert'
import i18n from '../assets/i18n/lang'
import {
    SPEECHES_TYPE_BURIAL_SPEECH,
    SPEECHES_TYPE_CEREMONY_SPEECH,
    SPEECHES_TYPE_DEATH_NOTICE
} from '../store/modules/speeches-types'

export const FileService = {
    uploadFile: (filename, file) => {
        return new Promise(
            function (resolve, reject) {
                const randStamp = (Date.now() / 1000 | 0) + Math.floor(Math.random() * 1000) + 1
                const filePath = 'user/' + firebase.auth().currentUser.uid + '/' + randStamp + '_' + filename
                firebase.storage().ref().child(filePath).put(file)
                    .then((snapshot) => resolve(snapshot))
                    .catch((error) => reject(error))
            })
    },
    downloadFile: (fbName, fbUrl) => {
        return new Promise(
            function (resolve, reject) {
                firebase.storage().ref().child(fbUrl).getDownloadURL()
                    .then((url) => {
                        const axiosConfig = {responseType: 'blob'}
                        return axios.get(url, axiosConfig)
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    downloadFileFromBackend: (id, documentType) => {
        return new Promise(
            function (resolve, reject) {
                let url = '/proteges/' + id
                if (documentType === SPEECHES_TYPE_BURIAL_SPEECH) url = url + '/burial-speech'
                else if (documentType === SPEECHES_TYPE_CEREMONY_SPEECH) url = url + '/ceremony-speech'
                else if (documentType === SPEECHES_TYPE_DEATH_NOTICE) url = url + '/death-notice'
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            OAlert.showSuccess('', i18n.t('feedback.fileSucDownload'))
                            resolve(response.data)
                        } else { reject(new Error('http status code other than 200: ' + response.status)) }
                    })
                    .catch((error) => { reject(error) })
            }
        )
    },
    downloadGenDocFromBackend: (id) => {
        return new Promise(
            function (resolve, reject) {
                let url = '/documents/general-docs/' + id
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            OAlert.showSuccess('', i18n.t('feedback.fileSucDownload'))
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            }
        )
    },
    downloadVideoFromBackend: (id) => {
        return new Promise(
            function (resolve, reject) {
                let url = '/documents/videos/' + id
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            OAlert.showSuccess('', i18n.t('feedback.fileSucDownload'))
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            }
        )
    },
    downloadProtegePhotoFromBackend: (protegeId, photoId) => {
        return new Promise(
            function (resolve, reject) {
                let url = '/proteges/' + protegeId + '/photos/' + photoId
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            // OAlert.showSuccess('', i18n.t('feedback.fileSucDownload'))
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            }
        )
    },
    downloadProtegeGenDocFromBackend: (protegeId, docId) => {
        return new Promise(
            function (resolve, reject) {
                let url = '/proteges/' + protegeId + '/general-docs/' + docId
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            // OAlert.showSuccess('', i18n.t('feedback.fileSucDownload'))
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            }
        )
    },
    downloadProtegeVideoFromBackend: (protegeId, videoId) => {
        return new Promise(
            function (resolve, reject) {
                let url = '/proteges/' + protegeId + '/videos/' + videoId
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            // OAlert.showSuccess('', i18n.t('feedback.fileSucDownload'))
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            }
        )
    },
    deletePhotoFromBackend: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/documents/photos/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            })
    },
    deleteGenDocFromBackend: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/documents/general-docs/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            })
    },
    deleteVideoFromBackend: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/documents/videos/' + id)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => reject(error))
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/file-service.js